import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerItemsToSynchronizeListResourceBundleEn(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'en',
    'record-it-components',
    {
      synchronization: {
        ItemsToSynchronizeList: {
          allItemsSynchronized: 'Everything synchronized',
          waitingForSynchronization: 'waiting for synchronization: {{ count }}'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
